import React from "react";
import { Route, Routes } from "react-router-dom";
import LoginView from "../screens/auth/login/LoginView";
import VerifyOTP from "../screens/auth/otp-verify/VerifyOtp";
import PublicLayout from "../components/layouts/public/PublicLayout";
import Welcome from "../screens/welcome/Welcome";
import User from "../screens/user/user";
import Trainer from "../screens/trainer/Trainer";
import Home from "../public/Home";
import InsightsViewInUse from "../public/insights-in-use/InsightsViewInUse";
import InsightsDetailsView from "../public/insights/InsightsDetailsView";
import EventsView from "../public/events/EventsView";
import AboutUs from "../public/about-us/AboutUs";
import EventDetail from "../public/events/EventDetail";
import ContactUsView from "../public/contact-us/ContactUsView";
import PrivacyPolicy from "../public/privacy-policy/PrivacyPolicy";
import TermsCondition from "../public/terms-condition/TermsCondition";
import { commonRoute } from "./RouteCommon";
import Offerings from "../public/offerings/Offerings";
import UnauthorizedAccess from "../screens/auth/unauthorizedAccess/UnauthorizedAccess";

const PublicRouter = () => {
  return (
    <Routes>
      <Route path="/" element={<PublicLayout />}>
        {/* this is for app.vprosper.in */}
        {/* <Route path="/" element={<Welcome />} /> */}
        <Route path={publicRoute.welcome} element={<Welcome />} />
        <Route path={publicRoute.home} element={<Home />} />
        <Route path={publicRoute.login} element={<LoginView />} />
        <Route path={publicRoute.verifyOTP} element={<VerifyOTP />} />
        <Route path={publicRoute.userVerification} element={<User />} />
        <Route path={publicRoute.trainer} element={<Trainer />} />
        <Route path={publicRoute.insights} element={<InsightsViewInUse />} />
        <Route path={publicRoute.events} element={<EventsView />} />
        <Route path={publicRoute.aboutUs} element={<AboutUs />} />
        <Route path={publicRoute.eventDetail} element={<EventDetail />} />
        <Route path={publicRoute.contactUs} element={<ContactUsView />} />
        <Route path={publicRoute.privacyPolicy} element={<PrivacyPolicy />} />
        <Route path={publicRoute.offerings} element={<Offerings />} />
        <Route
          path={publicRoute.termsAndCondition}
          element={<TermsCondition />}
        />
        <Route
          path={`${publicRoute.insightDetail}/:id/:slug`}
          element={<InsightsDetailsView />}
        />
        <Route
          path={unauthorizedAccess.unauthorizedAccess}
          element={<UnauthorizedAccess />}
        />
      </Route>
    </Routes>
  );
};

export default PublicRouter;

export const publicRoute = {
  welcome: "/welcome",
  userVerification: "user-verification",
  login: "log-in",
  verifyOTP: "verifyOTP",
  trainer: "join-as-trainer",
  home: "/",
  insights: "insights",
  events: "events",
  aboutUs: "about-us",
  eventDetail: "event-detail",
  contactUs: "contact-us",
  privacyPolicy: `${commonRoute.privacyPolicy}`,
  termsAndCondition: `${commonRoute.termsConditions}`,
  offerings: "offerings",
  insightDetail: "insights-detail",
};

export const unauthorizedAccess = {
  unauthorizedAccess: "unauthorizedAccess",
};
